import React, { Fragment, useContext } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink  } from 'reactstrap';
import { setCurrentEmployee, setCurrentUser } from 'features/Auth-Slice';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useDispatch } from 'react-redux';
import { setServiceMessages } from 'features/ServiceMessage-Slice';
import { appInsights } from 'appInsightsAuth';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { ConfigContext } from 'ConfigContextProvider';
import { Link } from 'react-router-dom';
import './NavMenu.css';

type DesktopNavProps = {
    children: React.ReactNode;
    collapsed: boolean;
    toggleNavbar: () => void;
}


function DesktopNavMenu({ children, collapsed, toggleNavbar }: DesktopNavProps) {
    const { instance } = useMsal();
    const [clientId, apiUrl, logoImage]: any = useContext(ConfigContext);
    const dispatch = useDispatch();
    
    const LoginUser = async () =>{
        try {
            instance.loginRedirect();
        } catch (err:any) {
            appInsights.trackException({ error: err, severityLevel: SeverityLevel.Error });
        }
    }
    
    const logoutUser = async () => {
        try {
            dispatch(setCurrentUser(null));
            dispatch(setCurrentEmployee(null));
            dispatch(setServiceMessages(null));
            await instance.logout();
        } catch (err:any) {
            appInsights.trackException({ error: err, severityLevel: SeverityLevel.Error });
        }
    }
    return (
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow mb-3" light>
            <NavbarToggler onClick={toggleNavbar} className="toggler" />
            <NavbarBrand tag={Link} to="/">
                <img src={logoImage} className="fleet-hire-logo" alt="fleet-solutions" />
            </NavbarBrand>
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse justify-content-between navbar-container" isOpen={!collapsed} navbar>
                <ul className="navbar-nav">
                    {children}
                    {useIsAuthenticated() ?
                        <Fragment>
                            <NavItem>
                                <NavLink tag={Link} to="/MyAccount/Details" onClick={() => toggleNavbar()}>Your Account</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="" onClick={logoutUser}>Logout</NavLink>
                            </NavItem>
                        </Fragment >
                        :
                        <Fragment>
                            <NavItem>
                                <NavLink tag = { Link } to="" onClick={LoginUser}>Login</NavLink>
                            </NavItem>
                        </Fragment>          
                    }
                </ul>
            </Collapse>
        </Navbar>
    );
}

export default DesktopNavMenu;
